import { ReactElement } from "react";

import LockImage from "../../assets/lock.svg";

interface LockModalProps {
  onCancel: () => void;
  text: string;
  subText: string;
  onConfirm?: () => void
}

const LockModal: React.FC<LockModalProps> = ({
  onCancel,
  text,
  subText,
  onConfirm
}: LockModalProps): ReactElement => {
  return (
    <div className="modal-container flex column align-center justify-center">
      <img src={LockImage} alt="kamco delete delete-customer" />
      <h3>{text}</h3>
      <p style={{ textAlign: "center" }}>{subText}</p>
      <div className="buttons-container flex align-center justify-space-between">
        <button className="cancel" onClick={onCancel}>
          Cancel
        </button>
        <button onClick={onConfirm}>Confirm</button>
      </div>
    </div>
  );
};

export default LockModal;
